(function($) {
    var $profileForm;
    var $saveButton;
    var securityInfoTemplate = {};
    var profileFormValidator = null;
    
    var validatePasswords = function() {
        var match = true;
        
        if ($('#changePasswordFields').hasClass('shown')) {
            var $passwordField = $('#newPassword');
            var $confirmPasswordField = $('#confirmPassword');
            var password = $passwordField.val().trim();
            var confirmPassword = $confirmPasswordField.val().trim();
            match = (password.length > 0 && password === confirmPassword);
            
            if (match) {
                $passwordField.removeClass('error errorborder');
                $confirmPasswordField.removeClass('error errorborder');
                $.clearStatus();
            }
        }
        
        return match;
    };
    
    var validateInputs = function(event) {
    	const forceEnableButton = !isInternalAuthentication || !$('#changePasswordFields').hasClass('shown');  
    	if (forceEnableButton) {
    		$saveButton.removeAttr('disabled');
    		return;
    	}
    	$validationPasswordField = $('#userProfilePassword');
    	var validationPassword = $validationPasswordField.val().trim();
        if (validatePasswords() && $('.errorborder').length === 0 && validationPassword.length>0) {
            $saveButton.removeAttr('disabled');
        } else {
            $saveButton.attr('disabled', 'disabled');
        }
    };
    
    var toggleChangePasswordField = function() {
        var $passwordsWrapper = $('#changePasswordFields');
        var $passwordFields = $('#changePasswordFields input');
        var $chevron = $('#changePassword i');
        
        if($passwordsWrapper.hasClass("shown")) {
            $chevron.removeClass('fa-rotate-90');
            $passwordsWrapper.removeClass('shown');
            $passwordFields.val("");
            profileFormValidator.element($('#newPassword'));
            profileFormValidator.element($('#confirmPassword'));
        } else {
            $chevron.addClass('fa-rotate-90');
            $passwordsWrapper.addClass('shown');
        }
        validateInputs();
    };
    
    var submitForm = function() {
        if ($profileForm.valid()) {
            
            var user = {
                name : currentUserName,
                email : $('#userProfileEmail').val(),
                password : $('#userProfilePassword').val()
                
            };

            if ($('#changePasswordFields').hasClass('shown')) {
                user.newPassword = $('#newPassword').val();
            }

            var encryptedUser = Crypto.encrypt(JSON.stringify({user :  user}));

            // Replacing slash with a temporary string 'slashcharfix' because it is messing up the REST URL.
            $.ajax({
                type: 'PUT',
                url : 'ws/userProfiles/' + encryptedUser.iv.replace(/\//g, slashCharFix),
                dataType : 'json',
                contentType : 'application/json',
                data : encryptedUser.encrypted,
                cache : false
            }).done(function(response) {
                if (!!response) {
                    if (!!response.success) {
                        $.showSuccessStatus(response.message);
                    } else {
                        $.showErrorStatus(response.message);
                    }
                } else {
                    $.showErrorStatus(unknownErrorMessage);
                }
            }).fail(function(jqXHR) {
                if (!!jqXHR && !!jqXHR.responseJSON) {
                    $.showErrorStatus(jqXHR.responseJSON.message);
                } else {
                    $.showErrorStatus(unknownErrorMessage);
                }
            });
        }
    };
    
    $(document).ready(function() {
        $profileForm = $('#profileForm');
        $saveButton = $('#saveButton');
        securityInfoTemplate = $('#securityItemTemplate').html().trim();
        $.validator.addMethod('passwordsMatch', validatePasswords, invalidNewPassword);
        $saveButton.attr('disabled', 'disabled');
        
        profileFormValidator = $profileForm.validate({
            rules : {
                userProfileEmail : {
                    required : false,
                    email : true
                },
                newPassword : {
                    required : {
                        depends : function() {
                            return $('#changePasswordFields').hasClass('shown');
                        }
                    },
                    passwordsMatch : true
                },
                confirmPassword : {
                    required : {
                        depends : function() {
                            return $('#changePasswordFields').hasClass('shown');
                        }
                    },
                    passwordsMatch : true
                }
            },
            errorPlacement: function (error, element) {
                var $element = $(element);
                $element.removeClass('valid');
                $element.addClass('errorborder');
                
                if ($element.is(':focus')) {
                    var message = error.html();
                    
                    if (message && message.length > 0) {
                        $.showErrorStatus(message);
                        $saveButton.attr('disabled', 'disabled');
                    }
                }
            },
            success : function(success, element) {
                $(element).removeClass('error errorborder');
    
                if (profileFormValidator.numberOfInvalids() === 0) {
                    $.clearStatus();
                }
            },
            onfocusin : function(element) {
                if (!$(element).hasClass('initial')) {
                    profileFormValidator.element(element);
                }
            },
            onfocusout : function(element) {
                $.clearStatus();
                $(element).removeClass('initial');
                profileFormValidator.element(element);
            },
            onkeyup : function(element, event) {
                if (event.which !== 9) { // tab key can be ignored because of focus out
                    $(element).removeClass('initial');
                    profileFormValidator.element(element);
                }
            }
        });
        
        $.getJSON('ws/userProfiles/' + encodeURIComponent(currentUserName)).done(function(response) {
            if (!!response) {
                if (!!response.userProfile) {
                    $('.profile-name').text(currentUserName);
                    $('#userProfileEmail').val(response.userProfile.user.email);
                    
                    var groups = response.userProfile.groups;
                    
                    if (!groups || ($.isArray(groups) && groups.length === 0) || (!$.isArray(groups) && !groups.name)) {
                        
                        groups = [{name : noGroups}];
                    }
                    
                    $('#groupInfoWrapper').html(Mustache.to_html(securityInfoTemplate, {data: groups}));
                    
                    var roles = response.userProfile.roles;

                    if (!roles || ($.isArray(roles) && roles.length === 0) || (!$.isArray(roles) && !roles.name)) {
                        
                        roles = [{name : noRoles}];
                    }
                    
                    $('#roleInfoWrapper').html(Mustache.to_html(securityInfoTemplate, {data: roles}));
                } else if (!!response.message) {
                    $.showErrorStatus(response.message);
                } else {
                    $.showErrorStatus(unknownErrorMessage);
                }
            } else {
                $.showErrorStatus(unknownErrorMessage);
            }
        }).fail(function(jqXHR) {
            if (!!jqXHR && !!jqXHR.responseJSON) {
                $.showErrorStatus(jqXHR.responseJSON.message);
            } else {
                $.showErrorStatus(unknownErrorMessage);
            }
        });
        
        $('#changePassword:not(".expired")').on('click', toggleChangePasswordField);
        $('#profileForm input').keyup(validateInputs);
        $saveButton.on('click', submitForm);
    });
})(jQuery);
